import { MaskedLines } from "./motion";

export default function PageHeader({ eyebrow, titleLines, intro, image, testid }) {
  return (
    <section data-testid={testid} className="relative overflow-hidden bg-obsidian">
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover opacity-55" loading="eager" />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/55 to-obsidian/35" />
      </div>
      <div className="container-site relative flex min-h-[52svh] flex-col justify-end pb-14 pt-32 sm:min-h-[58svh]">
        {eyebrow && <p className="label-eyebrow !text-terracotta-soft">{eyebrow}</p>}
        <MaskedLines
          lines={titleLines}
          className="mt-4 font-serif text-4xl font-medium leading-[1.06] tracking-tight text-cream sm:text-5xl lg:text-6xl"
        />
        {intro && <p className="mt-6 max-w-xl text-base leading-relaxed text-stone-300">{intro}</p>}
      </div>
    </section>
  );
}
